@if (button.text) {
  <a
    class="coro-btn"
    [ngClass]="['coro-btn--' + button.style, 'coro-btn--' + button.size]"
    [href]="button.link"
    [attr.aria-label]="button.ariaLabel || null"
    coreLinkClass>
    @if (button.hasIcon && button.iconPositionLeft) {
      <coro-icon [iconType]="button.iconType" position="left"></coro-icon>
    }
    <span [innerText]="button.text | translate"></span>
    @if (button.hasIcon && button.iconPositionRight) {
      <coro-icon [iconType]="button.iconType" position="right"></coro-icon>
    }
  </a>
}
